<template>
  <v-dialog v-model="navigation.CRMWhatsappConversationDialogIsVisible" @update:model-value="navigation.CRMWhatsappConversationDialogIsVisible == false ? closeCRMWhatsappConversationDialog() : null" max-width="75vw" :fullscreen="navigation.openInFullScreen">
    <v-card max-width="75vw">
      <div v-if="loader.selectCRMWhatsappConversationFromCRMWhatsappConversationDialog" style="width: 100%; text-align: center; margin: 10px 0px 10px 0px;">
        <v-progress-circular color="primary" indeterminate></v-progress-circular>
      </div>
      <div v-else>
        <WhatsappConversationComponent 
          :CRMWhatsappConversation="navigation.CRMWhatsappConversation"
          :CRMWhatsappConversationCurrentCRMAgentIsVisible="navigation.CRMWhatsappConversationCurrentCRMAgentIsVisible"
          :updateCRMWhatsappConversationIsPinnedIsActive="navigation.updateCRMWhatsappConversationIsPinnedIsActive"
          :CRMWhatsappConversationAssistanceIsActive="navigation.CRMWhatsappConversationAssistanceIsActive"
          :CRMWhatsappConversationNoteIsActive="navigation.CRMWhatsappConversationNoteIsActive"
          :CRMWhatsappConversationHistoryIsActive="navigation.CRMWhatsappConversationHistoryIsActive"
          :CRMWhatsappContactFollowupHistoryIsActive="navigation.CRMWhatsappContactFollowupHistoryIsActive"
          :transferCRMWhatsappConversationIsActive="navigation.transferCRMWhatsappConversationIsActive"
          :closeCRMWhatsappConversationIsActive="navigation.closeCRMWhatsappConversationIsActive"
          :rejectCRMWhatsappConversationIsActive="navigation.rejectCRMWhatsappConversationIsActive"
          :AIAssistantIsActive="false"
          :CRMWhatsappMessageIsActive="navigation.CRMWhatsappMessageIsActive"
          :maxHeight="navigation.openInFullScreen ? '100vh' : '80vh'"
        ></WhatsappConversationComponent>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>
  import WhatsappConversationComponent from '@/components/WhatsappConversationComponent.vue';
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      WhatsappConversationComponent
    },
    data: () => 
    ({
      navigation: 
      {
        CRMWhatsappConversationDialogIsVisible: false,
        CRMWhatsappConversationID: null,
        CRMWhatsappConversation: null,
        CRMWhatsappConversationCurrentCRMAgentIsVisible: false,
        updateCRMWhatsappConversationIsPinnedIsActive: false,
        CRMWhatsappConversationAssistanceIsActive: false,
        CRMWhatsappConversationNoteIsActive: false,
        CRMWhatsappConversationHistoryIsActive: false,
        CRMWhatsappContactFollowupHistoryIsActive: false,
        transferCRMWhatsappConversationIsActive: false,
        closeCRMWhatsappConversationIsActive: false,
        rejectCRMWhatsappConversationIsActive: false,
        AIAssistantIsActive: false,
        CRMWhatsappMessageIsActive: false,
        openInFullScreen: false
      },
      loader: 
      {
        selectCRMWhatsappConversationFromCRMWhatsappConversationDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods:
    {
      async selectCRMWhatsappConversationFromCRMWhatsappConversationDialog(){
        this.loader.selectCRMWhatsappConversationFromCRMWhatsappConversationDialog = true;
        const selectCRMWhatsappConversationFromCRMWhatsappConversationDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID
        };
        const selectCRMWhatsappConversationFromCRMWhatsappConversationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/selectCRMWhatsappConversationFromCRMWhatsappConversationDialog', selectCRMWhatsappConversationFromCRMWhatsappConversationDialogRequestQuery);
        if (selectCRMWhatsappConversationFromCRMWhatsappConversationDialogResult.success){
          const CRMWhatsappConversation = selectCRMWhatsappConversationFromCRMWhatsappConversationDialogResult.result;
          CRMWhatsappConversation.CRMWhatsappMessages.forEach(CRMWhatsappMessage => {
            CRMWhatsappMessage.CRMWhatsappConversationID = CRMWhatsappConversation.CRMWhatsappConversationID;
          });
          this.loader.selectCRMWhatsappConversationFromCRMWhatsappConversationDialog = false;
          this.navigation.CRMWhatsappConversation = CRMWhatsappConversation;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappConversationFromWhatsappConversationDialog_error', 'error', 'Ha ocurrido un error inesperado al abrir la conversación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.navigation.CRMWhatsappConversationDialogIsVisible = false;
        }
      },

      async getSystemInformationData() {
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },
    
      async openCRMWhatsappConversationDialog(CRMWhatsappConversationID, CRMWhatsappConversationCurrentCRMAgentIsVisible, updateCRMWhatsappConversationIsPinnedIsActive, CRMWhatsappConversationAssistanceIsActive, CRMWhatsappConversationNoteIsActive, CRMWhatsappConversationHistoryIsActive, CRMWhatsappContactFollowupHistoryIsActive, transferCRMWhatsappConversationIsActive, closeCRMWhatsappConversationIsActive, rejectCRMWhatsappConversationIsActive, AIAssistantIsActive, CRMWhatsappMessageIsActive, openInFullScreen){        
        await this.getSystemInformationData();
        this.loader.selectCRMWhatsappConversationFromCRMWhatsappConversationDialog = false;
        this.navigation.CRMWhatsappConversationID = CRMWhatsappConversationID;
        this.navigation.CRMWhatsappConversationCurrentCRMAgentIsVisible = CRMWhatsappConversationCurrentCRMAgentIsVisible;
        this.navigation.updateCRMWhatsappConversationIsPinnedIsActive = updateCRMWhatsappConversationIsPinnedIsActive;
        this.navigation.CRMWhatsappConversationAssistanceIsActive = CRMWhatsappConversationAssistanceIsActive;
        this.navigation.CRMWhatsappConversationNoteIsActive = CRMWhatsappConversationNoteIsActive;
        this.navigation.CRMWhatsappConversationHistoryIsActive = CRMWhatsappConversationHistoryIsActive;
        this.navigation.CRMWhatsappContactFollowupHistoryIsActive = CRMWhatsappContactFollowupHistoryIsActive;
        this.navigation.transferCRMWhatsappConversationIsActive = transferCRMWhatsappConversationIsActive;
        this.navigation.closeCRMWhatsappConversationIsActive = closeCRMWhatsappConversationIsActive;
        this.navigation.rejectCRMWhatsappConversationIsActive = rejectCRMWhatsappConversationIsActive;
        this.navigation.AIAssistantIsActive = AIAssistantIsActive;
        this.navigation.CRMWhatsappMessageIsActive = CRMWhatsappMessageIsActive;
        this.navigation.openInFullScreen = openInFullScreen;
        this.navigation.CRMWhatsappConversationDialogIsVisible = true;
        this.selectCRMWhatsappConversationFromCRMWhatsappConversationDialog();
      },

      closeCRMWhatsappConversationDialog() {
        this.navigation.CRMWhatsappConversationDialogIsVisible = false;
        this.$emit('closeCRMWhatsappConversationDialog');
      }
    }
  }
</script>